// extracted by mini-css-extract-plugin
export default {"vertical-dots":"CustomNoteCard_vertical-dots__YhYOs","option-icon":"CustomNoteCard_option-icon__q525n"};